<script setup lang="ts">
defineProps<{
  checked?: boolean
  truncate?: boolean
}>()

defineEmits(['click'])
</script>

<template>
  <button
    class="min-h-9 focus:ring-secondary-200 group relative flex w-full items-center rounded-md p-2 pr-4 outline-none ring-offset-2 focus:ring focus:ring-2"
    :class="{
      'bg-secondary-50 text-secondary-dark': checked,
      'hover:bg-neutral-light text-neutral-900': !checked,
    }"
    type="button"
    @click="$emit('click')"
  >
    <div
      class="i-ph-check mr-2 h-5 w-5"
      :class="{
        'opacity-0': !checked,
        'opacity-100': checked,
      }"
    />
    <div
      class="body-2 w-full max-w-prose text-left text-neutral-900"
      :class="{
        'truncate whitespace-nowrap': truncate,
      }"
    >
      <slot />
    </div>
  </button>
</template>
